import angular from 'angular';

import {
  groupCrudService,
  listCrudService,
  roleCrudService,
  userCrudService,
  searchService,
  treeService,
  signCertificataService,
  flowExecutionService,
  flowService,
  workflowUploadService,
  additionalFieldCrudService,
  companyCrudService,
  contractCrudService,
  documentTypeCrudService,
  repositoryCrudService,
  systemConfigService,
  mediaService,
  emailService,
  additionalFieldService,
  folderService,
  onlyOfficeService,
  supportService,
  nfeService,
  notificationService,
  previewService,
  dashboardService,
  fileCheckinUploadService,
  fileReplaceUploadService,
  fileUploadService,
  linkFilesService,
  publicLinkService,
  chatbotService,
  ragIntegrationService,
  digitalizationService,
  revService,
  revisionService,
  revisionListService,
  shareRevisionService,
  uploadRevisionService,
  documentsPagingService,
  authInterceptorService,
  authService,
  extensionInstallService,
  signDocumentService,
  signDocumentD4sService,
  signedDocumentSealService,
  scriptLoaderService,
  validationService,
  watermarkService,
} from '../services';

const module = 'app.services';
const requires = [];

angular.module(module, requires);

angular.module(module).registerComponents(
  {
    groupCrudService,
    listCrudService,
    roleCrudService,
    userCrudService,
    searchService,
    treeService,
    signCertificataService,
    flowExecutionService,
    flowService,
    workflowUploadService,
    additionalFieldCrudService,
    companyCrudService,
    contractCrudService,
    documentTypeCrudService,
    repositoryCrudService,
    systemConfigService,
    mediaService,
    additionalFieldService,
    emailService,
    folderService,
    onlyOfficeService,
    supportService,
    nfeService,
    notificationService,
    previewService,
    dashboardService,
    fileCheckinUploadService,
    fileReplaceUploadService,
    fileUploadService,
    linkFilesService,
    publicLinkService,
    chatbotService,
    ragIntegrationService,
    digitalizationService,
    revService,
    revisionService,
    revisionListService,
    shareRevisionService,
    uploadRevisionService,
    documentsPagingService,
    authService,
    authInterceptorService,
    extensionInstallService,
    signDocumentService,
    signDocumentD4sService,
    signedDocumentSealService,
    scriptLoaderService,
    validationService,
    watermarkService,
  },
  'factory'
);
